import {
  CUSTOMER_ADMIN_BANNER_HEIGHT_PX,
} from '@/components/layout/CustomerAdminBanner';
import { ISSUE_MAINTENANCE_BANNER_HEIGHT_PX } from '@/modules/announcements/constants';
import { useIsCustomerAdminBannerVisible } from '@/lib/auth/useIsCustomerAdminBannerVisible';
import { useIssueMaintenanceBanner } from '@/hooks/useIssueMaintenanceBanner';

/**
 * Computes stacked top-banner geometry for {@link AppLayout}.
 * Stack order (top to bottom): admin impersonation, issue/maintenance (red,
 * global). News/NewVersion are no longer surfaced as a top banner — they show
 * in the dashboard body via {@link UpdateBanner}.
 */
export function useTopBannerLayout() {
  const customerAdminBannerVisible = useIsCustomerAdminBannerVisible();
  const { announcement, isVisible: issueMaintenanceBannerVisible, dismiss } =
    useIssueMaintenanceBanner();

  const adminHeight = customerAdminBannerVisible ? CUSTOMER_ADMIN_BANNER_HEIGHT_PX : 0;
  const issueHeight = issueMaintenanceBannerVisible
    ? ISSUE_MAINTENANCE_BANNER_HEIGHT_PX
    : 0;

  return {
    customerAdminBannerVisible,
    issueMaintenanceBannerVisible,
    issueMaintenanceAnnouncement: announcement,
    dismissIssueMaintenanceBanner: dismiss,
    topBannerOffsetPx: adminHeight + issueHeight,
    issueMaintenanceBannerTopPx: adminHeight,
  };
}
